import React, { FC, useMemo, useState } from "react";
import { TrainableRow, TrainableTable } from "../markup/referenceViewer/trainableTables";
import { TrainingTableGrid } from "./trainingTable";
import { shuffle } from "./shuffle";
import { Message, PrimaryButton, TableTitle } from "./trainUi";

interface RandomTrainingProps {
    tables: TrainableTable[];
}

interface Item {
    table: TrainableTable;
    row: TrainableRow;
}

export const RandomTraining: FC<RandomTrainingProps> = ({ tables }) => {
    const items = useMemo<Item[]>(() => {
        const flat: Item[] = [];
        for (const table of tables)
            for (const row of table.rows)
                flat.push({ table, row });
        return shuffle(flat);
    }, [tables]);

    const [index, setIndex] = useState(0);
    const [answerShown, setAnswerShown] = useState(false);

    if (index >= items.length)
        return <Message>Done ✓ — {items.length} rows reviewed</Message>;

    const { table, row } = items[index];

    const next = () => {
        setAnswerShown(false);
        setIndex(index + 1);
    };

    return (
        <div>
            {table.title.length > 0 && <TableTitle>{table.title}</TableTitle>}
            <TrainingTableGrid
                header={table.header}
                colCount={table.colCount}
                rows={[{ cells: row.cells, revealedColumns: answerShown ? table.colCount : 1 }]}
            />
            {answerShown ? (
                <PrimaryButton type="button" onClick={next}>Next ▸</PrimaryButton>
            ) : (
                <PrimaryButton type="button" onClick={() => setAnswerShown(true)}>Show answer</PrimaryButton>
            )}
        </div>
    );
};
